import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { SuggestionsDTO } from './dto/suggestions.dto';
import { SuggestionsService } from './suggestions.service';
import { AllSuggestionsResponseModel, SuggestionsResponseModel } from '@gtpl/shared-models/hrms';
import { SuggestionsRequest } from './dto/suggestions.request';
import { request } from 'express';


@Controller('suggestions')
@ApiTags('suggestions')
export class SuggestionsController {
    constructor(
        private service: SuggestionsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}


    @Post('/createSuggestions')
    async createSuggestion(@Body() dto: SuggestionsDTO): Promise<SuggestionsResponseModel>{
        try{
         return await this.service.createSuggestion(dto, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(SuggestionsResponseModel, error);
        }
    }

    @Post('/updateSuggestion')
    async updateSuggestion(@Body() dto: SuggestionsDTO): Promise<SuggestionsResponseModel>{
        try{
            return await this.service.createSuggestion(dto, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(SuggestionsResponseModel, error);
        }
    }

    @Post('/getAllSuggestions')
    async getAllSuggestions(): Promise<AllSuggestionsResponseModel>{
        try{
            return await this.service.getAllSuggestions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllSuggestionsResponseModel, error);
        }
    }

    @Post('activateOrDeactivateSuggestion')
    async activateOrDeactivateSuggestion(@Body() req: SuggestionsRequest): Promise<SuggestionsResponseModel>{
        try{
            return await this.service.activateOrDeactivateSuggestion(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(SuggestionsResponseModel, error);
        }
    }
}
